export const DUMPSTER_API = 'https://dumpstermap.herokuapp.com'
